module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "icon": "plus",
      "size": "mini"
    },
    on: {
      "click": _vm.addTemplate
    }
  }, [_vm._v("添加宣传链接")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "链接内容",
      "size": "mini"
    },
    model: {
      value: (_vm.params.content),
      callback: function($$v) {
        _vm.$set(_vm.params, "content", $$v)
      },
      expression: "params.content"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "所属类型"
    },
    on: {
      "change": _vm.typesearch
    },
    model: {
      value: (_vm.params.content_type),
      callback: function($$v) {
        _vm.$set(_vm.params, "content_type", $$v)
      },
      expression: "params.content_type"
    }
  }, _vm._l((_vm.content_types), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "size": "mini",
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "链接类型"
    },
    on: {
      "change": _vm.typesearch
    },
    model: {
      value: (_vm.params.links_type),
      callback: function($$v) {
        _vm.$set(_vm.params, "links_type", $$v)
      },
      expression: "params.links_type"
    }
  }, _vm._l((_vm.links_types), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "size": "mini",
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.data,
      "height": _vm.wheight - 130
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "链接内容",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content_type",
      "label": "所属类型",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "links_type",
      "label": "链接类型",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "links",
      "label": "链接地址",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.links) ? _c('a', {
          attrs: {
            "href": scope.row.links,
            "target": "_blank"
          }
        }, [_vm._v("地址")]) : _c('a', {
          attrs: {
            "href": "#"
          }
        }, [_vm._v("暂无设置")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "transit_links",
      "label": "中转链接",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operator_id",
      "label": "操作员ID",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operator_name",
      "label": "操作员姓名",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created_at",
      "label": "数据生成时间",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("datetime")(scope.row.created_at, 'yyyy-MM-dd hh:mm:ss')))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updated_at",
      "label": "数据更新时间",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("datetime")(scope.row.updated_at, 'yyyy-MM-dd hh:mm:ss')))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operating-icons"
        }, [_c('i', {
          staticClass: "iconfont icon-edit1",
          on: {
            "click": function($event) {
              return _vm.editAction(scope.$index, scope.row)
            }
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "mark iconfont icon-trash-alt1",
          on: {
            "click": function($event) {
              return _vm.deleteAction(scope.$index, scope.row)
            }
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加、编辑宣传链接",
      "width": "40%",
      "visible": _vm.memberTagDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.memberTagDialog = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.form,
        "label-width": "100px"
      }
    }, [_c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "所属类型"
      }
    }, [_c('el-radio-group', {
      attrs: {
        "size": "small"
      },
      model: {
        value: (_vm.form.content_type),
        callback: function($$v) {
          _vm.$set(_vm.form, "content_type", $$v)
        },
        expression: "form.content_type"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": "商品",
        "border": ""
      }
    }, [_vm._v("商品")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "专题",
        "border": ""
      }
    }, [_vm._v("专题")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "品牌",
        "border": ""
      }
    }, [_vm._v("品牌")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "充余额",
        "border": ""
      }
    }, [_vm._v("充余额")])], 1)], 1), _vm._v(" "), (_vm.form.content_type == '商品') ? _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "选择商品"
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "55%"
      },
      attrs: {
        "filterable": "",
        "placeholder": "请输入商品货号",
        "remote": "",
        "remote-method": _vm.getItemShopsList
      },
      on: {
        "change": _vm.handleItemShopsChange
      },
      model: {
        value: (_vm.relItemsShops),
        callback: function($$v) {
          _vm.relItemsShops = $$v
        },
        expression: "relItemsShops"
      }
    }, _vm._l((_vm.relItemsShopsList), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }]
    }, [_c('el-col', [_c('el-input', {
      model: {
        value: (_vm.relItemsShopsVal),
        callback: function($$v) {
          _vm.relItemsShopsVal = $$v
        },
        expression: "relItemsShopsVal"
      }
    })], 1)], 1)], 1) : _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "链接内容",
        "prop": "content"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "链接内容"
      },
      model: {
        value: (_vm.form.content),
        callback: function($$v) {
          _vm.$set(_vm.form, "content", $$v)
        },
        expression: "form.content"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "链接类型"
      }
    }, [_c('el-radio-group', {
      attrs: {
        "size": "small"
      },
      model: {
        value: (_vm.form.links_type),
        callback: function($$v) {
          _vm.$set(_vm.form, "links_type", $$v)
        },
        expression: "form.links_type"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": "h5",
        "border": ""
      }
    }, [_vm._v("h5")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "custom",
        "border": ""
      }
    }, [_vm._v("custom")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "wxapp",
        "border": ""
      }
    }, [_vm._v("wxapp")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "随机码"
      }
    }, [_c('el-radio-group', {
      attrs: {
        "size": "small"
      },
      model: {
        value: (_vm.form.rand_flg),
        callback: function($$v) {
          _vm.$set(_vm.form, "rand_flg", $$v)
        },
        expression: "form.rand_flg"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": "0",
        "border": ""
      }
    }, [_vm._v("非随机")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "1",
        "border": ""
      }
    }, [_vm._v("随机")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "连接地址",
        "prop": "cate_name"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "连接地址"
      },
      model: {
        value: (_vm.form.links),
        callback: function($$v) {
          _vm.$set(_vm.form, "links", $$v)
        },
        expression: "form.links"
      }
    })], 1), _vm._v(" "), (_vm.form.links_type == 'wxapp') ? _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "小程序中转",
        "prop": "cate_name"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "小程序中转"
      },
      model: {
        value: (_vm.form.transit_links),
        callback: function($$v) {
          _vm.$set(_vm.form, "transit_links", $$v)
        },
        expression: "form.transit_links"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.saveData
      }
    }, [_vm._v("确定保存")])], 1)], 1)]
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-10e01292", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10e01292"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/publicity/publicity_links.vue
// module id = 2472
// module chunks = 0